import { useQuery } from '@tanstack/react-query';

import { PredictedDistanceWithDutiesAndAntiDumping } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useGoodsItemPredictedDistances = (declarationId: string, goodsItemId: string) =>
  useQuery({
    queryKey: ['goodsItemPredictedDistances', goodsItemId],
    queryFn: async (): Promise<PredictedDistanceWithDutiesAndAntiDumping[]> => {
      try {
        const { data } = await request({
          path: `declarations/${declarationId}/goods-shipment-item/${goodsItemId}/predicted-distances`,
          method: 'GET',
          authenticate: true,
        });

        return data;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch predictions!');
      }
    },
  });
